import script from "./PainPoints.vue?vue&type=script&setup=true&lang=js"
export * from "./PainPoints.vue?vue&type=script&setup=true&lang=js"

import "./PainPoints.vue?vue&type=style&index=0&id=18de6a90&lang=scss&scoped=true"

import exportComponent from "/Users/rioschan/Downloads/event-2022electrolux-main/vue-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18de6a90"]])

export default __exports__